import React from 'react';

const DataScience = () => {
  return (
    <div>
      DataScience
      DataScience
    </div>
  );
}

export default DataScience;
